import React from 'react'

import styles from './FormCombinedBlock.module.scss'

const FormCombinedBlock = ({ children }) => <li className={styles.formCombinedBlock}>{children}</li>

export default FormCombinedBlock
